import React, { Component } from "react";
import Navigation from "../../components/Navigation";
import { Checkbox } from "nq-component";
import BasePage from "../../base/BasePage";
import ContactUsPagePresenter from "./ContactUsPagePresenter";
import { signOutUseCase } from "../../usecases/user";
import Socials from "../../components/socialbottom";

const contacts = [
  {
    icon: "bi-envelope-open",
    title: "Email",
    details: ["lgs.staff.hr@gmail.com", "lgs.staff.hr1@gmail.com"],
  },
  {
    icon: "bi-telephone",
    title: "Phone",
    details: ["+63 2 8889-2680"],
  },
  {
    icon: "bi-geo-alt",
    title: "Office",
    details: [
      "LGS Centre, 1639 Dian corner, Rockefeller St. Brgy. San Isidro, Makati City",
    ],
  },
];

class ContactUsPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new ContactUsPagePresenter(this, signOutUseCase());
  }

  logout() {
    this.presenter.onClickSignOut();
  }

  render() {
    return (
      <>
        <Navigation logout={this.logout.bind(this)} />
        <div
          className="d-flex p-5 container-fluid justify-content-between flex-lg-row flex-column flex-column-reverse"
          style={{ marginTop: `7rem` }}
        >
          <div className="p-3">
            <div>
              <h1 className="fw-bold">
                Contact <i style={{ color: `#D18237` }}>Us</i>
              </h1>
              <p
                className="py-2 text-muted fs-4"
                style={{ width: `85%`, color: `#303030BF` }}
              >
                We'd love to hear from you. Please fill out this form, and we'll
                reply soon.
              </p>
            </div>
            {/* <div className="d-flex flex-column mt-5 justify-content-center mb-2">
              {contacts.map((contact, index) => (
                <div key={index} className="d-flex gap-4 align-items-center">
                  <div
                    className="d-flex justify-content-center align-items-center align-self-baseline"
                    style={{
                      backgroundColor: "#D1823780",
                      borderRadius: "50%",
                      width: "4.1rem",
                      height: "4.1rem",
                    }}
                  >
                    <i
                      className={`bi ${contact.icon} fs-5`}
                      style={{ color: "#D18237" }}
                    ></i>
                  </div>

                  <div className="col gap-1 p-2">
                    <h4 className="fw-bold" style={{ color: `#303030BF` }}>
                      {contact.title}
                    </h4>
                    {contact.details.map((detail, i) => (
                      <p
                        key={i}
                        className="fs-5"
                        style={{ color: `#303030BF` }}
                      >
                        {detail}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </div> */}
            <div className="d-flex flex-column mt-5 justify-content-center mb-2">
              {contacts.map((contact, index) => (
                <div key={index} className="d-flex gap-4 align-items-center">
                  {/* Icon container */}
                  <div
                    className="d-flex justify-content-center align-items-center icon-container"
                    style={{
                      backgroundColor: "#D1823780",
                      borderRadius: "50%",
                      width: "4.1rem",
                      height: "4.1rem",
                      minWidth: "4.1rem", // Ensures all icons align
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <i
                      className={`bi ${contact.icon} fs-5`}
                      style={{ color: "#D18237" }}
                    ></i>
                  </div>

                  {/* Text container */}
                  <div className="col gap-1 p-2">
                    <h4 className="fw-bold" style={{ color: `#303030BF` }}>
                      {contact.title}
                    </h4>
                    {contact.details.map((detail, i) => (
                      <p
                        key={i}
                        className="fs-5"
                        style={{ color: `#303030BF` }}
                      >
                        {detail}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col bg-white rounded-4 p-5 me-5 col-md-9 col-lg-4 col-12">
            <form className="gap-3">
              <h2 className="fw-bold fs-3">Write us a message</h2>
              <div className="col mt-4">
                <p>Name</p>
                <input
                  type="text"
                  placeholder="Juan Dela Cruz"
                  className="border border1 rounded-2 p-3 w-100 fs-6"
                ></input>
              </div>
              <div className="col mt-4">
                <p>Email</p>
                <input
                  type="email"
                  placeholder="juan@mail.com"
                  className="border border1 rounded-2 p-3 w-100 fs-6"
                ></input>
              </div>
              <div className="col mt-4">
                <p>Message</p>
                <textarea
                  rows="4"
                  cols="50"
                  className="w-100 rounded-2 p-3 border border-1 fs-6"
                  placeholder="Message"
                  style={{ resize: `none` }}
                ></textarea>
              </div>
              <div className="d-flex py-2 align-middle">
                <Checkbox></Checkbox>
                <p>
                  I agree to the{" "}
                  <span style={{ color: `#3174AD` }}>Privacy Policy</span>
                </p>
              </div>
              <button
                type="submit"
                className="btn w-100 py-3 fw-bold rounded-2 text-white fs-6"
                style={{ backgroundColor: `#D18237` }}
              >
                Submit
              </button>
            </form>
          </div>
        </div>
        <div className="container-fluid text-center">
          {/* <div className="container-fluid text-center">
            <img
              src="/lgs.png"
              className="img-fluid w-50 w-md-25 w-lg-25"
              alt="Responsive Image"
            />
          </div> */}
          <div className="container-fluid text-center">
            <img
              src="/lgs.png"
              className="img-fluid w-50"
              style={{ maxWidth: "200px" }} // Set a max width to control the size on larger screens
              alt="Responsive Image"
            />
          </div>

          <p className="fw-bold pt-2">
            Providing you the BEST service just when you need it the most.
          </p>
        </div>
        <Socials />
      </>
    );
  }
}

export default ContactUsPage;
